<div class="m-t-25"></div>
<div *ngIf="(numberOfServices.length > 0) || isMpSevereHasData ||normalHasdata">

    <div class="" style="overflow-x: hidden;">
        <div class="row">
            <div class="col-sm-6" >
                <div *ngIf="vehicleBrandIsNotOV">
                    <div *ngIf="!showCurrentService">
                            <mat-button-toggle-group 
                                name="fontStyle" 
                                aria-label="Font Style"  
                                #group="matButtonToggleGroup" 
                                class="maintenance-switch"
                                [value]="selectedVal" 
                                (change)="onValChange(group.value)">
                                    <mat-button-toggle class="maintenance-switch-text" value="NORMAL"><span translate>dimbo.i18n.button.Normal</span> </mat-button-toggle>
                                    <mat-button-toggle class="maintenance-switch-text" value="SEVERE"><span translate>dimbo.i18n.button.Severe </span></mat-button-toggle>
                            </mat-button-toggle-group>  
                    </div>

                    <div *ngIf="showCurrentService">
                        <mat-button-toggle-group 
                            name="fontStyle" 
                            aria-label="Font Style"  
                            #group="matButtonToggleGroup" 
                            class="maintenance-switch"
                            [value]="selectedVal" 
                            (change)="onValChange(group.value)">
                                <mat-button-toggle [disabled]="showCurrentService" class="maintenance-switch-text" style="opacity: 0.3;" value="NORMAL" ><span translate>dimbo.i18n.button.Normal</span></mat-button-toggle>
                                <mat-button-toggle [disabled]="showCurrentService" class="maintenance-switch-text" style="opacity: 0.3;" value="SEVERE" ><span translate>dimbo.i18n.button.Severe</span></mat-button-toggle>
                        </mat-button-toggle-group>  
                    </div>
                    
                </div>
                
            </div> 
            <div class="col-sm-6 float-right" *ngIf ="!showCurrentService && (numberOfServices.length > 0)">
                <div *ngIf="!isReadOnly">
                    <div *ngIf="customerVeficationRetryCount > 0">
                        <div class="float-right print-button print-button-text" (click)="createService()" translate>dimbo.i18n.button.CreateService</div>
                    </div>
                    

                </div>
                
            </div>
        </div>
    </div>

    <div class="container-fluid" *ngIf="numberOfServices.length > 0">
        <div class="row m-b-15 m-t-20">
            <div class="col-sm-4 service-header-text"><span style="padding-left: 48px;" translate>dimbo.i18n.header.TypeofService</span></div>
            <div class="col-sm-4 service-header-text"><span style="padding-left: 27px;" translate>dimbo.i18n.header.Frequency</span></div>
            <div class="col-sm-3 service-header-text"><span *ngIf="hasPlanned" style="padding-left: 6px;" translate>dimbo.i18n.header.PlanningStatus</span></div>
        </div>
    </div>

    <div class="containter-fluid default-bg-color" >
        
        <mat-selection-list #services>
            <mat-list-option 
                checkboxPosition="before" 
                *ngFor="let service of typesOfServices; let i = index" 
                (click)="onServiceListControlChanged(services, i)"
                [value]="service.id"
                class="service-list">
                <div class="row">
                    <div class="col-sm-4 maintenance-service-name-text" style="margin-top: 2px;">{{service.serviceName}}</div>
                    <div class="col-sm-4 service-frequency-text" style="margin-top: 2px;">{{service.stepFrequency}}</div>

                    <div class="col-sm-3">
                        <span *ngIf="service.stepFrequency && service.statusLabel && service.statusCode !== '1'" class="status-code{{service.statusCode}}" >{{service.statusLabel}}</span>
                    </div>

                    
                </div>
            </mat-list-option>
        </mat-selection-list>
    </div>

    <!-- Current Service Section -->
    <div class="default-bg-color m-t-20" *ngIf ="showCurrentService">
        <form #myform = "ngForm" (ngSubmit) = "onSubmit(myform)" >
            <div class="container-fluid">
                <div *ngIf="selectedOption.length > 0" class="float-left print-button print-button-text" (click)="addService(); services.deselectAll()" translate>dimbo.i18n.button.Add</div>
                <div *ngIf="selectedOption.length < 1" class="float-left print-button print-button-text" style="opacity: 0.3;" translate>dimbo.i18n.button.Add</div>
            </div>
            <br>
            <br>
            <div class="container-fluid">
                <div class="current-service-header-text m-t-25" translate>dimbo.i18n.header.CurrentService</div>
            </div>
            <div class="container-fluid bg-color-white m-t-20 m-b-25" style="box-shadow: 4px 4px 6px 4px rgb(245, 241, 241); min-height: 300px;">
                <div class="row justify-content-start">

                    <!-- Maintaenance Operation section -->
                    <div class="col-sm-6 m-b-20">
                        <p class="m-t-20 maintenance-operation-text" translate>dimbo.i18n.header.MaintenanceOperation</p>
                        <div class="row">
                            <div class="col-sm-11">
                                <mat-selection-list #addedServices [multiple]="false">
                                    <mat-list-option  *ngFor="let operation of singleserviceoperation"  [value]="operation.maintenancePlanReference" class="service-list">
                                        <div class="row">
                                            <div class="col-sm-8 maintenance-service-name-text">{{operation.label}}</div>
                                            <div class="col-sm-2">
                                                <span class="material-icons float-right" (click)="onServiceOperationChanged(operation)">
                                                    delete_outline
                                                </span>
                                            </div>
                                        </div>
                                    </mat-list-option>
                                </mat-selection-list> 
                            </div>
                            
                        </div>

                        <div class="row">
                            <div class="col-sm-11">
                                <mat-form-field style="width: 100%;">
                                    <mat-label translate>dimbo.i18n.label.Comment</mat-label>
                                    <textarea  name ="servicehistorycomment" matInput [(ngModel)]="servicehistorycomment" [value]="servicehistorycomment" maxlength="4000" ></textarea>
                                </mat-form-field>
                            </div>
                            
                        </div>
                        

                        
                    </div>

                    <div class="m-t-20 vertical-line"></div>

                    <!-- Antiperforation section -->
                    <div class="col-sm-5 ">
                        <div class="row m-t-20">
                            <div class="">
                                <span class="p-l-30 m-t-20 maintenance-operation-text" translate>dimbo.i18n.header.AntiPerforationCheck</span>
                                <span class="m-l-20 m-t-20">
                                    <mat-slide-toggle  
                                    name="isAntiPerforationCheck"
                                    [checked]="isAntiPerforationCheck === true ? true : false"
                                    (change)="setAntiperforation( $event )"></mat-slide-toggle>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="isAntiPerforationCheck" >
                            <div class="row">
                                <div class="col-sm-6 m-t-30 m-l-30 anti-perforation-text" translate>dimbo.i18n.label.AntiPerforationInspection</div>
                                <div class="col-sm-5 float-left">
                                    <mat-form-field>
                                        <mat-select [(ngModel)]="antiperforationperiod" name="antiperforationperiod">
                                            <mat-option *ngFor="let year of numberOfYears" [value]="year">
                                                {{year}} <span translate>dimbo.i18n.label.Year</span>
                                            </mat-option>
                                            <mat-option [value]="greaterage">10+ <span translate>dimbo.i18n.label.Year</span></mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div> 
                            </div>
                            <div class="row">
                                <span class="m-l-30 p-l-15 anti-perforation-text" translate>dimbo.i18n.label.AntiPerforationIssueDetected</span>
                                <span class="m-l-20">
                                    <mat-slide-toggle [checked]="issueDetected === true ? true : false" name="issueDetected" (change)="setIssueDetected( $event )"></mat-slide-toggle>
                                </span>
                            </div>
                            <div class="row" *ngIf="issueDetected">
                                <mat-form-field class="m-l-30 p-l-15" style="width: 100%;">
                                    <mat-label translate>dimbo.i18n.label.Comment</mat-label>
                                    <textarea matInput [(ngModel)]="antiperforationcomment" name="antiperforationcomment"
                                    [value]="antiperforationcomment" maxlength="4000"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                </div>
                

            </div>

            
            <input *ngIf="singleserviceoperation.length > 0" class="float-right print-button print-button-text m-r-10 m-t-10" style="padding-top: 7px;" type="submit" [value]="submittranlation">
            <input *ngIf="singleserviceoperation.length < 1" class="float-right print-button print-button-text m-r-10 m-t-10" style="padding-top: 7px; opacity: 0.3;" type="button" [value]="submittranlation">
            
            <input class="float-right cancel-button cancel-button-text m-r-10 m-t-10" type="button" (click) = resetMaintenance() [value]="canceltranlation"> 
            
            
        </form>
    </div>

</div>

<div *ngIf="typesOfServices.length < 1" class="vehicle-info-description float-left">
</div>